var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClass,attrs:{"type":"button","disabled":_vm.disabled,"title":_vm.title},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }